import * as list from './list';
import * as send from './send';

export default {
  ...list,
  ...send,
};
